/**
 * The plan editor's one cursor rule: what the pointer shows over each kind
 * of target, from the canvas's mode. Every canvas part asks here, so 瀏覽 /
 * 編輯模式 / a placing tool read the same everywhere.
 *
 * Modes (canvasMode):
 *   browse  瀏覽: a drag pans, so the canvas shows grab (grabbing mid-pan)
 *           and every item inherits it rather than promising a move.
 *   edit    編輯模式 with no tool on.
 *   place   編輯模式 with a tool waiting for a canvas click (palette symbol,
 *           越線 add, 可行區域 draw).
 *
 * Targets: canvas, item (station or symbol), vertex (可行區域 handle),
 * tripwire (its body), tripwireEnd (a plane endpoint handle), lane (a handle
 * that slides along the lane: a line/tunnel gate or a tunnel link).
 * A locked item (on a layout that is not the active one) is the arrow.
 */
const EDIT_CURSORS = {
  canvas: { edit: "default", place: "crosshair" },
  item: { edit: "move", place: "move" },
  vertex: { edit: "grab", place: "pointer" },
  tripwire: { edit: "pointer", place: "pointer" },
  tripwireEnd: { edit: "grab", place: "grab" },
  lane: { edit: "ew-resize", place: "ew-resize" },
};

export const canvasMode = (editing, placing) =>
  !editing ? "browse" : placing ? "place" : "edit";

export const editorCursor = (
  mode,
  target,
  { dragging = false, locked = false } = {},
) => {
  if (locked) return "default";
  if (mode === "browse") {
    if (target !== "canvas") return "inherit";
    return dragging ? "grabbing" : "grab";
  }
  const cursor = EDIT_CURSORS[target]?.[mode] ?? "default";
  return cursor === "grab" && dragging ? "grabbing" : cursor;
};
